import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/devices/devices.scss";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import { Button } from "react-bootstrap";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";

class DeviceDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      deviceDetails: [],
    };
  }

  async componentDidMount() {
    let deviceId = this.props.match.params.id;
    this.props.setLoadingPageAction(true);

    try {
      let deviceDetails = await axios.get(
        `${apiHost}/api/Device/SelectDevice/${deviceId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ deviceDetails: deviceDetails.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  handleSubmit = () => {
    this.props.history.push(`/editDevice/${this.state.deviceDetails.id}`);
  };

  render() {
    const { deviceDetails } = this.state;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Device Details </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Device Details</h2>
              <h6>Details</h6>
              <hr />
              <div className="deviceDetails">
                <div className="individualDetail">
                  <p className="left"> IMEI</p>
                  <p className="right">{deviceDetails.imei} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Name</p>
                  <p className="right"> {deviceDetails.name} </p>
                </div>
                <div className="individualDetail">
                  <p className="left">Description</p>
                  <p className="right">{deviceDetails.description}</p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Customer</p>
                  <p className="right">{deviceDetails.customerName}</p>
                </div>

                <div className="individualDetail">
                  <p className="left">Asset</p>
                  <p className="right">{deviceDetails.assetName}</p>
                </div>
                <div className="individualDetail">
                  <p className="left"> SIM</p>
                  <p className="right">{deviceDetails.simNumber}</p>
                </div>
                <div className="individualDetail">
                  <p className="left">Type</p>
                  <p className="right"> {deviceDetails.type}</p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Tag</p>
                  <p className="right">{deviceDetails.tag} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Status</p>
                  <p className="right">{deviceDetails.deviceStatus} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Software</p>
                  <p className="right">{deviceDetails.software} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Hardware</p>
                  <p className="right">{deviceDetails.hwVersion} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Firmware</p>
                  <p className="right">{deviceDetails.firmware} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> ExtData</p>
                  <p className="right"> {deviceDetails.extData}</p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Last Connected</p>
                  <p className="right">{deviceDetails.lastMessageTime ? utcToLocal(deviceDetails.lastMessageTime) : ''} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Created</p>
                  <p className="right">
                    {utcToLocal(deviceDetails.dbCreated)}{" "}
                  </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Updated</p>
                  <p className="right">
                    {deviceDetails.dbUpdated ? utcToLocal(deviceDetails.dbUpdated) : ''}{" "}
                  </p>
                </div>
              </div>
              <div className="footer-menu">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    //this.props.history.push("/devices");
                    this.props.history.goBack();
                  }}
                >
                  Back to List
                </Button>
                &nbsp;
                <Button
                  size="sm"
                  variant="primary"
                  onClick={this.handleSubmit.bind(this)}
                >
                  Edit
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDetails);
